import { Action } from "@ngrx/store";
import { PageParams } from "../models/navigation-settings.model";

export const SET_PAGE_PARAMS = "SET_PAGE_PARAMS";
export const GET_PAGE_PARAMS = "GET_PAGE_PARAMS";

export class SetPageParams implements Action {
  readonly type = SET_PAGE_PARAMS;
  constructor(public payload: PageParams) {}
}

export class GetPageParams implements Action {
  readonly type = GET_PAGE_PARAMS;
}

export type Actions = SetPageParams | GetPageParams;
